import { AuthenticationType } from 'dy-frontend-http-repository/lib/modules/Auth/enums';

const authenticationPriority: { [key in AuthenticationType]: number } = {
    [AuthenticationType.GOOGLE]: 1,
    [AuthenticationType.EMAIL_PASSWORD]: 0,
};

export default authenticationPriority;
